package com.evoapps.evoshift.ui.whatsnew

import com.evoapps.evoshift.widgets.MenuRowCard
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.outlined.NewReleases
import androidx.compose.material3.Card
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.cardClickable
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.EvoBottomSheet
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.help_got_it
import evoshift.composeapp.generated.resources.whats_new_employee_1
import evoshift.composeapp.generated.resources.whats_new_employee_2
import evoshift.composeapp.generated.resources.whats_new_employee_3
import evoshift.composeapp.generated.resources.whats_new_employee_4
import evoshift.composeapp.generated.resources.whats_new_employee_5
import evoshift.composeapp.generated.resources.whats_new_manager_1
import evoshift.composeapp.generated.resources.whats_new_manager_2
import evoshift.composeapp.generated.resources.whats_new_manager_3
import evoshift.composeapp.generated.resources.whats_new_manager_4
import evoshift.composeapp.generated.resources.whats_new_manager_5
import evoshift.composeapp.generated.resources.whats_new_open
import evoshift.composeapp.generated.resources.whats_new_open_desc
import evoshift.composeapp.generated.resources.whats_new_subtitle
import evoshift.composeapp.generated.resources.whats_new_title
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/**
 * The notes of the current release (SH-146), 3-5 points per role from the string resources.
 * A release with new notes changes [RELEASE] and the strings; the sheet then shows once more
 * after the update.
 */
object WhatsNew {
    /** The notes in the app now: Ukrainian, the picker, training, breaks on the watch, Mac. */
    const val RELEASE = "2026-10-language"

    /** Owners and managers. */
    val forManagers: List<StringResource> = listOf(
        Res.string.whats_new_manager_1,
        Res.string.whats_new_manager_2,
        Res.string.whats_new_manager_3,
        Res.string.whats_new_manager_4,
        Res.string.whats_new_manager_5
    )

    /** Employees. */
    val forEmployees: List<StringResource> = listOf(
        Res.string.whats_new_employee_1,
        Res.string.whats_new_employee_2,
        Res.string.whats_new_employee_3,
        Res.string.whats_new_employee_4,
        Res.string.whats_new_employee_5
    )

    fun notes(forManager: Boolean): List<StringResource> = if (forManager) forManagers else forEmployees
}

object WhatsNewTags {
    const val SHEET = "whats_new_sheet"
    const val CARD = "whats_new_card"
    fun point(index: Int) = "whats_new_point_$index"
}

/** The sheet: a title, "In this version of EVoShift", the points and "Got it". */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun WhatsNewSheet(forManager: Boolean, onDismiss: () -> Unit) {
    EvoBottomSheet(
        onDismiss = onDismiss,
        title = stringResource(Res.string.whats_new_title),
        subtitle = stringResource(Res.string.whats_new_subtitle),
        icon = Icons.Outlined.NewReleases
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().testTag(WhatsNewTags.SHEET),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            WhatsNew.notes(forManager).forEachIndexed { index, note ->
                Row(Modifier.fillMaxWidth().testTag(WhatsNewTags.point(index))) {
                    Text("•", color = LightGold, modifier = Modifier.padding(end = 10.dp))
                    Text(stringResource(note), style = MaterialTheme.typography.bodyMedium, color = Color.White.copy(alpha = 0.9f))
                }
            }
        }
        EvoPrimaryButton(DialogAction(stringResource(Res.string.help_got_it), onDismiss), Modifier.fillMaxWidth())
    }
}

/** Profile, next to the help centre: reopens the notes of this version. */
@Composable
fun WhatsNewCard(forManager: Boolean) {
    var open by rememberSaveable { mutableStateOf(false) }
    MenuRowCard(Icons.Outlined.NewReleases, stringResource(Res.string.whats_new_open), onClick = { open = true }, modifier = Modifier.testTag(WhatsNewTags.CARD), subtitle = stringResource(Res.string.whats_new_open_desc))
    if (open) WhatsNewSheet(forManager = forManager, onDismiss = { open = false })
}
